import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { PeriodExaminationApi } from "../../../api/period_examination/period_examination.api";
import { dateToView } from "../../../utils/date.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "period_examination_name", width: 300, sortable: true, disablePadding: false, align: 'left', label: t("PERIOD_EXAMINATION_NAME")
        },
        {
            id: "examination_name", disablePadding: false, sortable: true, width: 300, align: "left", label: t("PERIOD_EXAMINATION_EXAM_NAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("PERIOD_EXAMINATION_EXAM_DATE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("PERIOD_EXAMINATION_TOTAL_EXAMINEES")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("PERIOD_EXAMINATION_PASS_SCORE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("PERIOD_EXAMINATION_TOTAL_PASS")
        },
        {
            id: "modified_date", disablePadding: false, sortable: true, align: "center", width: 200, label: t("PERIOD_EXAMINATION_CREATED_UPDATED_DATE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("PERIOD_EXAMINATION_CREATED_UPDATED_BY")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            examination_name,
            modified_by,
            created_date,
            modified_date,
            period_examination_start_date,
            id_period_examination,
            period_examination_name,
            student_count,
            period_examination_pass,
            student_pass_count

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: period_examination_name || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: examination_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(period_examination_start_date) || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: student_count || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: period_examination_pass || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: student_pass_count || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <IconButton onClick={() => navigate(routeName.admission.period_examination_detail?.replace(':id', `${id_period_examination}`))}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (keyword) query = { ...query, search: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await PeriodExaminationApi.getPeriodExaminationList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate, sortType, sortBy])


    useEffect(() => {
        handleGetData()
    }, [handleGetData])



    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

    }
}

export default ManageState